import type { DirectChannel, Message } from '@/types/api';

/** Only a sanitized DM participant snapshot may refresh cached DM author tags.
 * Guild/profile updates must never restore a tag hidden in direct messages. */
export function reconcileDmTeams(messages: Message[] | undefined, channel: DirectChannel) {
  if (!messages) return messages;
  const tags = new Map(channel.directParticipants.map(p => [p.userId, p.user.teamTag ?? null]));
  let changed = false;
  const next = messages.map(message => {
    if (!tags.has(message.authorId)) return message;
    const teamTag = tags.get(message.authorId) ?? null;
    if (message.author.teamTag === teamTag) return message;
    changed = true;
    return { ...message, author: { ...message.author, teamTag } };
  });
  return changed ? next : messages;
}
